import { gatewayInstance } from "../../axiosInstance";

// Base API Endpoints
const BASE_FINANCE = "/financeservice";
const RATE_MANAGER_BASE = `${BASE_FINANCE}/ratemanager`;
const PATTERN_BASE = `${BASE_FINANCE}/pattern`;

/**
 * Standardized API Error Handler
 * Logs the error and re-throws it so consuming hooks/components can handle UI toasts/alerts.
 */
const handleApiError = (error, contextMsg = "API Error") => {
    console.error(`[RateManager API] ${contextMsg}:`, error?.response?.data || error.message || error);
    throw error;
};

// ==========================================
// 1. Charge & Pattern Endpoints
// ==========================================

export const getCharges = async () => {
    try {
        const response = await gatewayInstance.get(PATTERN_BASE);
        return response.data;
    } catch (error) {
        return handleApiError(error, "Failed to fetch charges");
    }
};

export const getChargePatterns = async (chpCharge) => {
    try {
        const response = await gatewayInstance.get(`${PATTERN_BASE}/${chpCharge}`);
        const data = response?.data;

        if (!Array.isArray(data)) return [];

        return data.map((pattern) => ({
            key: pattern.chpId,
            text: pattern.chpPatternName,
            value: JSON.stringify({
                chpId: pattern.chpId,
                chpUomGroup: pattern.chpUomGroup,
                chpRateLocStatus: pattern.chpRateLocStatus,
            }),
        }));
    } catch (error) {
        return handleApiError(error, `Failed to fetch charge patterns for charge: ${chpCharge}`);
    }
};

// ==========================================
// 2. Rate Master Query & Search Endpoints
// ==========================================

export const searchRates = async (searchCriteria) => {
    try {
        const response = await gatewayInstance.post(`${RATE_MANAGER_BASE}/search`, searchCriteria);
        return response.data;
    } catch (error) {
        return handleApiError(error, "Failed to search rates");
    }
};

export const getRate = async (rateId) => {
    try {
        const response = await gatewayInstance.get(`${RATE_MANAGER_BASE}/${rateId}`);
        return response.data;
    } catch (error) {
        return handleApiError(error, `Failed to fetch rate with ID: ${rateId}`);
    }
};

export const getDuplicateRates = async (ratePayload) => {
    try {
        const response = await gatewayInstance.post(`${RATE_MANAGER_BASE}/check-duplicate`, ratePayload);
        return response.data;
    } catch (error) {
        return handleApiError(error, "Failed to check duplicate rates");
    }
};

// ==========================================
// 3. Rate Master Mutation Endpoints (CUD)
// ==========================================

export const saveRate = async (ratePayload) => {
    try {
        return await gatewayInstance.post(RATE_MANAGER_BASE, ratePayload);
    } catch (error) {
        return handleApiError(error, "Failed to save rate");
    }
};

export const updateRate = async (ratePayload) => {
    try {
        return await gatewayInstance.put(RATE_MANAGER_BASE, ratePayload);
    } catch (error) {
        return handleApiError(error, "Failed to update rate");
    }
};

export const copyRate = async (copyPayload) => {
    try {
        return await gatewayInstance.post(`${RATE_MANAGER_BASE}/rate-copy`, copyPayload);
    } catch (error) {
        return handleApiError(error, "Failed to clone rate");
    }
};